import { render, staticRenderFns } from "./BaseTabs.vue?vue&type=template&id=5ed9cc20&scoped=true"
import script from "./BaseTabs.vue?vue&type=script&lang=js"
export * from "./BaseTabs.vue?vue&type=script&lang=js"
import style0 from "./BaseTabs.vue?vue&type=style&index=0&id=5ed9cc20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed9cc20",
  null
  
)

export default component.exports